/*
 * @flow
 */
import React from 'react';
import { Button } from 'sarsaparilla';
import ProgressBar from './ProgressBar';
import type { starCounts as starCountsType } from '../model/aggregate';

type PropTypes = {
  total: number,
  starCounts: starCountsType,
  value: string,
  onChange: Function,
};

export default class RatingBreakout extends React.PureComponent<PropTypes> {
  buildBreakout() {
    const { total, starCounts, onChange } = this.props;
    const breakout = [];
    for (let i = 5; i > 0; i--) {
      const ratings = starCounts[i.toString()];
      breakout.push(
        <div key={`rating-breakout-line-${i}`} className="rating-breakout-line">
          <Button appearance={'link'} isDisabled={ratings < 1} onClick={() => onChange(`${i}`)}>
            {i} stars
          </Button>

          <ProgressBar total={total} interval={ratings} />
          <span className="ratings">{ratings}</span>
        </div>
      );
    }
    return breakout;
  }
  render() {
    const { value, onChange } = this.props;
    return (
      <div className="rating-breakout-wrapper">
        {value && (
          <div className="clear-rating-wrap">
            <div>
              Showing Reviews with: <strong>{value} Stars</strong>
            </div>
            <Button appearance="link" onClick={() => onChange('')}>
              {' '}
              Remove Filter{' '}
            </Button>
          </div>
        )}
        {this.buildBreakout()}
      </div>
    );
  }
}
